export enum CartItemType {
    Product = 'product',
    Configuration = 'configuration',
    Custom = 'custom',
}